import { render, staticRenderFns } from "./whatsapp-plus.vue?vue&type=template&id=1f617faa&scoped=true"
import script from "./whatsapp-plus.vue?vue&type=script&lang=js"
export * from "./whatsapp-plus.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-plus.vue?vue&type=style&index=0&id=1f617faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f617faa",
  null
  
)

export default component.exports